import { useDialog } from 'hooks/common';

/**
 * Hook to manage app content expansion configuration.
 *
 * @returns {object} An object containing the current state and methods to expand/contract the app content.
 */
const useExpandAppContentConfig = () => {
  const { open: isContentExpanded, toggleDialog: toggleExpandContent } =
    useDialog();

  const APP_SIDEBAR_CLASS = 'spark_app_sidebar';
  const APP_HEADER_CLASS = 'spark_app_header';
  const EXPAND_CONTENT_CLASS = 'spark_content_expand';

  // Styles to be applied when content is expanded

  //Apply transition on the Header component by height
  const stylesImplemented = {
    [`:has(.${EXPAND_CONTENT_CLASS})`]: {
      [`& .${APP_HEADER_CLASS}`]: {
        height: 0,
        overflow: 'hidden',
      },
      [`& .${APP_SIDEBAR_CLASS}`]: {
        '& .MuiDrawer-paper': {
          height: '100vh !important',
          top: '0px !important',
          marginTop: 0,
        },
      },
    },
  };

  const classes = {
    header: APP_HEADER_CLASS,
    expandFlag: EXPAND_CONTENT_CLASS,
    sidebar: APP_SIDEBAR_CLASS,
  };
  return {
    isContentExpanded,
    toggleExpandContent,
    stylesImplemented,
    expandAppClasses: classes,
  };
};

export default useExpandAppContentConfig;
